import { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import FloatingWhatsApp from "../components/FloatingWhatsApp";
import Hero from "../components/Hero";
import TrustPillars from "../components/TrustPillars";
import Calculator from "../components/AICalculator";
import VerifiedResults from "../components/VerifiedResults";
import PropertyCategories from "../components/PropertyCategories";
import HowItWorks from "../components/HowItWorks";
import AIQualificationExample from "../components/AIQualificationExample";
import Coverage from "../components/Coverage";
import Achievements from "../components/Achievements";
import Roadmap from "../components/Roadmap";
import CaseStudies from "../components/CaseStudies";
import BrandLogos from "../components/BrandLogos";
import Trust from "../components/Trust";
import PlaybookDownload from "../components/PlaybookDownload";
import Pricing from "../components/Pricing";
import OnboardingSteps from "../components/OnboardingSteps";
import LeadForm from "../components/LeadForm";
import FAQ from "../components/FAQ";

export default function HomePage() {
    useEffect(() => {
        document.title = "Lead Krafts | OTP-Verified Real Estate Leads";
    }, []);

    return (
        <div data-testid="home-page" className="min-h-screen bg-[#050507] text-white">
            <Header />
            <main>
                <Hero />
                <TrustPillars />
                <Calculator />
                <VerifiedResults />
                <PropertyCategories />
                <HowItWorks />
                <AIQualificationExample />
                <Coverage />
                <Achievements />
                <Roadmap />
                <CaseStudies />
                <BrandLogos />
                <Trust />
                <PlaybookDownload />
                <Pricing />
                <OnboardingSteps />
                <LeadForm />
                <FAQ />
            </main>
            <Footer />
            <FloatingWhatsApp />
        </div>
    );
}
